// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyADSYiYdls0lWuWWde-8Kr9bCG6l60K8LY",
  authDomain: "safecoin-ec8e0.firebaseapp.com",
  databaseURL: "https://safecoin-ec8e0-default-rtdb.firebaseio.com",
  projectId: "safecoin-ec8e0",
  storageBucket: "safecoin-ec8e0.appspot.com",
  messagingSenderId: "461710433602",
  appId: "1:461710433602:web:b4eb6586ae29640ec67cdb",
  measurementId: "G-R9R8C2NMP1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const provider = new GoogleAuthProvider();
